var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('router-link',{attrs:{"to":"/user-agreement"}},[_vm._v("Пользовательское соглашение")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }